export const AUTH_BASE_URL =
  import.meta.env.VITE_AUTH_BASE_URL ?? 'https://auth.dev.mydra.io'
export const AUTH_LOGIN_URL = `${AUTH_BASE_URL}/login`
export const AUTH_SIGNUP_URL = `${AUTH_BASE_URL}/sign-up`
export const AUTH_LOGOUT_URL = `${AUTH_BASE_URL}/auth/logout`
